export default "__VITE_ASSET__DkRddGcf__"